/*eslint-disable*/
import {
  commonApi,
  common
} from '@/common/index'
import {
  mapState,
  mapActions,
  mapMutations
} from "vuex";
const gamePageBanner = {
  data() {
    return {
      // 其他页面
      banner: '',
      bannerLink: '',

      // 首页轮播
      indexBannerList: [],
      indexBannerLinkList: []
    }
  },
  computed: {
    ...mapState({
      isLogin: (state) => state.isLogin,
    }),
    mySwiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  methods: {
    ...mapMutations([
      "setShowLoginBox",
      "setOpenInviteUsers",

    ]),
    getBannerList() {
      commonApi.HOMEBEFORE.fetchImg(this.bannerCode)
        .then((list) => {
          this.banner = list[0].imgLink;
          this.bannerLink = list[0].imgClickLink;
          // 首页轮播
          this.indexBannerList = list;
          this.initIndexBannerLinkList()
        })
        .catch(err => {})
    },
    initIndexBannerLinkList() {
      if (this.indexBannerList.length > 0) {
        let arr = [];
        this.indexBannerList.forEach((item) => {
          arr.push(item.imgClickLink)
        });
        // 将第一个链接添加到最后，对应swiper复制到最后一个
        this.indexBannerLinkList = [...arr, arr[0]];
      }
    },
    indexBannerGoHref(e) {
      if (e.target.tagName.toLowerCase() !== 'img') return;
      let index = this.mySwiper.activeIndex - 1;
      let link = this.indexBannerLinkList[index];
      this.goBannerHref(link)
    },
    goBannerHref(url) {
      if (!url) return;
      if (url === "#/inviteUsersActivity") {
        if (!this.isLogin) {
          this.setShowLoginBox(true);
        } else {
          this.setOpenInviteUsers(true);
        }
      } else if(url.includes(':')&&url.split(":")[0]) {
        let key = url.split(":")[0];
        switch (key) {
          // 对暗号活动
          case "secretSignal":
          this.$router.push('/secretSignal');
          break;
        };
      } else {
        let path = common.goHref(url);
        if (path) {
          this.$router.push({
            path
          })
        }
      }

    }
  },
  mounted() {
    this.bannerCode && this.getBannerList()
  }
};
export default gamePageBanner



// WEBPACK FOOTER //
// ./src/common/mixins/banner-codeImg/bannerCodeImg.js